/**
 * Компонент radioButton
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import EventEmitter from 'eventemitter3'
import uuid from '../../utils/uuid'
import { injectSheet } from '../../theme'
import { isolateMixin, focusSourceMixin, ifMobile } from '../../utils/mixins'
import { RADIO_INPUT_CONTEXT } from '../../constants/context'
import { ImageLoading } from '../ImageLoding'
import '../../utils/focus-source'
import * as uiActions from '../../../actions/ui'

function isSimpleType(value) {
  const type = typeof value
  return (
    type === 'string' ||
    type === 'number' ||
    type === 'boolean' ||
    value === null ||
    value === undefined
  )
}

@injectSheet(
  theme => ({
    root: {
      extend: isolateMixin,
      fontFamily: theme.fontFamily,
      fontSize: theme.radio.fontSize,
      border: 'none',
      padding: '5px',
      margin: '0',
      width: '33%', //todo: !
      cursor: 'pointer',
      position: 'relative',
      color: theme.radio.colors.default.text,
      userSelect: 'none',
      '$color&': {
        width: '20%',
        ...ifMobile({
          width: '20%',
        })
      },
      ...ifMobile({
        width: '50%',
      })
    },
    isDisabled: {
      pointerEvents: 'none',
      color: theme.radio.colors.disabled.text,
      cursor: 'not-allowed'
    },
    real: {
      fontFamily: theme.fontFamily,
      position: 'absolute',
      opacity: '0',
      appearance: 'none',
      pointerEvents: 'none'
    },
    labelText: {
      textAlign: 'center',
      padding: '5px'
    },
    labelWrapper: {
      border: '1px solid #C4C4C4',
      padding: 0,
      display: 'block',
      width: '100%',
      textAlign: 'center',
      borderRadius: '2.5px',
      ...ifMobile({
        borderRadius: '2.5px',
        borderColor: '#C4C4C4'
      }),
      position: 'relative',
      verticalAlign: 'middle',
      '$isChecked &': {
        border: '1px solid',
        transition: '.02s',
        background: 'white'
      },
      '$isEnabled:hover &': {
        transition: '.02s',
        background: '#f7f7f7'
      },
      '$image &': {
        /*borderColor: theme.radio.colors.hover.dotBorder,
        color: theme.radio.colors.hover.dot*/
      }

    },
    labelInner: {
      display: 'block',
      width: ' 100%',
      height: '100%',
      overflow: 'hidden',

      '$image &': {
        //padding: '20px',
        paddingBottom: '10px',
        ...ifMobile({
          padding: '18px 17px',
        })
      },
      '$image & $labelText': {
        //padding: '10px',
        ...ifMobile({
          padding: '0',
          fontSize: '12px',
          lineHeight: '100%',
          color: '#444444',
        })
      },


    },
    imageImg: {
      width: '100%',
      margin: '0 auto 1rem',
      height: 'auto',
      ...ifMobile({
        width: '100%',
        margin: '0 auto 10px',
      })
    },
    textImg: {
      width: '100%',
      padding: '20px',
      height: 'auto',
    },
    colorImg: {
      width: '100%',
      padding: '20px',
      height: 'auto',
    },
    text: {

    },
    image: {
      '$labelWrapper': {
      },
      textAlign: 'center'
    },
    color: {

    },
    fake: {
      flex: 'none',
      verticalAlign: 'middle',
      boxSizing: 'border-box',
      display: 'none',
      position: 'absolute',
      top: 0,
      right: 0,
      height: '20px',
      width: '20px',
      borderRadius: '20px',
      background: '#000 url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNy4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgOCA4IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA4IDgiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTYuNCwxTDUuNywxLjdMMi45LDQuNUwyLjEsMy43TDEuNCwzTDAsNC40bDAuNywwLjdsMS41LDEuNWwwLjcsMC43bDAuNy0wLjdsMy41LTMuNWwwLjctMC43TDYuNCwxTDYuNCwxeiINCgkvPg0KPC9zdmc+DQo=) no-repeat center center',
      backgroundSize: '50%',
      opacity: 0,
      zIndex: 9,
      '$isChecked &': {
        display: 'block',
        opacity: 1,
      },
      '$isEnabled:hover &': {
        borderColor: '#999999',
        color: theme.radio.colors.hover.dot
      },
      ...focusSourceMixin('other', '$real:focus + &', {
        borderColor: theme.radio.colors.focus.dotBorder
      }),
      '$isEnabled:active &': {
        borderColor: '#444444',
        background: theme.radio.colors.active.dotBackground,
        color: theme.radio.colors.active.dot
      },
      '$isDisabled &': {
        borderColor: theme.radio.colors.disabled.dotBorder,
        color: theme.radio.colors.disabled.dot
      },
      '$labelright &': {
      },
      '$labelleft &': {
      }
    },
    label: {
      width: '100%',
      textAlign: 'center',
      position: 'relative',
      verticalAlign: 'middle',
      height: '100%',
      display: 'flex',
      '$isChecked &': {
        boxShadow: '0 6px 24px rgba(0,0,0,.1)',
        transition: '.02s'
      }
    },
    isChecked: {},
    isEnabled: {},
    labelleft: {},
    labelright: {}
  }),
  { name: 'BlockButton' }
)
class BlockButton extends Component {

  static propTypes = {
    /**
     * Выбранное значение radioButton
     */
    value: PropTypes.any.isRequired,
    /**
     * Если true, BlockButton задизэйблен
     */
    disabled: PropTypes.bool,
    /**
     * Css-класс root-компонента(radioButton)
     */
    className: PropTypes.string,

    attrValue: PropTypes.any,
    /**
     * Css-класс span-radio
     */
    radioClassName: PropTypes.string,
    /**
     * Css-класс span-label
     */
    labelClassName: PropTypes.string,
    /**
     * Переопределение стандартных стилей компонента radioButton
     */
    style: PropTypes.object,
    /**
     * Переопределение стандартных стилей label
     */
    labelStyle: PropTypes.object,
    /**
     * Позиция label - либо слева, либо справа
     */
    labelPosition: PropTypes.oneOf(['left', 'right']),
    variation: PropTypes.oneOf(['regular', 'image', 'text', 'color'])
  }

  static defaultProps = {
    labelPosition: 'right',
    value: null,
    disabled: false,
    style: {},
    displayLabel: true,
    labelStyle: {},
    labelTextInner: false
  }

  static contextTypes = {
    [RADIO_INPUT_CONTEXT]: PropTypes.shape({
      getValue: PropTypes.func,
      getName: PropTypes.func,
      events: PropTypes.instanceOf(EventEmitter)
    })
  }

  get isChecked() {
    return this.inputValue === this.context[RADIO_INPUT_CONTEXT].getValue()
  }

  UNSAFE_componentWillMount() {
    this.setInputValue(this.props.value)
    this.context[RADIO_INPUT_CONTEXT].events.on(
      'updateValue',
      this.onUpdateValue
    )
  }

  componentWillUnmount() {
    this.context[RADIO_INPUT_CONTEXT].events.removeListener(
      'updateValue',
      this.onUpdateValue
    )
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value)
      this.setInputValue(nextProps.value)
  }

  componentDidMount() {
    if (this.input) this.input.checked = this.isChecked
  }

  componentDidUpdate() {
    if (this.input) this.input.checked = this.isChecked
  }

  setInputValue(value) {

    this.inputValue = value
    this.stringValue = isSimpleType(value) ? String(value) : uuid()
  }
  shouldComponentUpdate(newProps, newState) {
    return (newProps.checked !== this.props.checked || newProps.disabled !== this.props.disabled)
  }
  onUpdateValue = () => {
    this.forceUpdate()
  }

  onChange = e => {
    this.context[RADIO_INPUT_CONTEXT].events.emit(
      'newValue',
      e,
      this.props.value
    )
    // оставляем для обратной совместимости
    if (this.props.onChange) this.props.onChange(e, this.inputValue)
  }

  onInfoButtonClick = (e) => {
    e.preventDefault()
    store.dispatch(uiActions.infoButtonClicked(true))
  }

  render() {
    const {
      children,
      labelPosition,
      disabled,
      className,
      radioClassName,
      labelClassName,
      style,
      labelText,
      labelTextInner,
      labelStyle,
      variation,
      attrValue,
      hexColor,
      objectId,
      classes,
      displayLabel,
      onFocus,
      onBlur,
      theme, // eslint-disable-line no-unused-vars
      value, // eslint-disable-line no-unused-vars
      onChange, // eslint-disable-line no-unused-vars
      displayInfoButton,
      imageUrl,
      lebelInjection,
      ...other
    } = this.props

    const rootClassName = classnames(
      className,
      classes.root,
      classes[variation],
      classes[`label${labelPosition}`],
      disabled ? classes.isDisabled : classes.isEnabled,
      this.isChecked && classes.isChecked
    )

    let styles = {};
    if (variation === 'font') {
      styles.labelText = { fontFamily: labelText }
    };


    const getInversedTextColor = (color) => {
      const blackFontColorCriteria = new Set(['#ffffff', '#efeacb', '#fbf5c5'])
      if (blackFontColorCriteria.has(String.prototype.toLocaleLowerCase.call(color))) {
        return 'black';
      }
      return 'white';
    }

    return (
      <label className={rootClassName} style={style} {...other}>
        <input
          className={classes.real}
          type="radio"
          ref={input => {
            this.input = input
          }}

          name={this.context[RADIO_INPUT_CONTEXT].getName()}
          value={this.stringValue}
          disabled={disabled}
          onChange={this.onChange}
          onFocus={onFocus}
          onBlur={onBlur}
        />
        <span className={classnames(radioClassName, classes.fake)} />
        <span
          className={classnames(labelClassName, classes.label)}
          style={labelStyle}>
          <div className={classnames(classes.labelWrapper)}>
            <div className={classnames(classes.labelInner)}>
              {variation === 'image' &&
                <ImageLoading
                  className={classnames(classes.imageImg)}
                  src={imageUrl}
                />
              }
              {variation === 'color' &&
                <div
                  //className={classnames(classes.colorImg)}
                  style={{ backgroundColor: hexColor }}
                >
                  {labelTextInner &&
                    <div style={{ color: getInversedTextColor(hexColor) }}>
                      {labelText}
                    </div>
                  }
                </div>
              }
              {
                displayLabel &&
                <div
                  className={classes.labelText}
                  style={styles.labelText}
                >
                  <div style={
                    { display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
                    {labelText}
                    {lebelInjection}
                  </div>
                </div>
              }
            </div>
          </div>
        </span>


      </label>
    )
  }
}

BlockButton.displayName = 'ruiBlockButton'
export default BlockButton
